import { z } from 'zod';
export const FeatureFlag = z.object({
    key: z.string(),
    scope: z.string(), // 'global' | 'tenant:<uuid>'
    enabled: z.boolean(),
    valueJson: z.unknown().nullable(),
    rolloutPct: z.number().int().min(0).max(100),
    updatedBy: z.string().uuid().nullable(),
    updatedAt: z.string().datetime(),
});
export const UpdateFeatureFlagRequest = z.object({
    enabled: z.boolean(),
    valueJson: z.unknown().optional(),
    rolloutPct: z.number().int().min(0).max(100).optional(),
});
//# sourceMappingURL=feature-flag.js.map